/**
 * `document.referrer`가 야놀자 웹(`https://*.yanolja*`)인지 여부를 반환한다.
 *
 * 단, 오류 페이지(`/404` 등)면 거짓을 반환한다.
 */
export const isReferrerYaWeb = (): boolean =>
  !!(
    document.referrer &&
    /https?:\/\/[a-z_\-\\.]+\.yanolja\.com(?<port>:8080)?\/(?![4-5][0-9]{2})/.test(document.referrer)
  );

/**
 * `document.referrer`가 야놀자 웹이면 `history.back()`을 호출한다.
 * @param path - 이동할 경로.
 * @param exclude - 추가로 `referrer`에서 제외할 때 사용할 정규표현식.
 */
export const forceBackFromExternal = (path: string, exclude?: RegExp): void => {
  if (isReferrerYaWeb() && (exclude ? !exclude.test(document.referrer) : true)) {
    history.back();
    return;
  }
  location.replace(path);
};
